import { MagicConfigMixin, isoDate, getLanguageTagBCP47, fromIsoDate, acceptedExpiryDate, reasonableDateOfBirth, validAge, maxValidAge, validDay, validMonth, validYear } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var DateField;
(function(DateField2) {
  DateField2[DateField2["NONE"] = 0] = "NONE";
  DateField2[DateField2["DAY"] = 1] = "DAY";
  DateField2[DateField2["MONTH"] = 2] = "MONTH";
  DateField2[DateField2["YEAR"] = 3] = "YEAR";
})(DateField || (DateField = {}));
let DateComponent = class extends Mixins(validationMixin, MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.fullDate = {
      day: null,
      month: null,
      year: null
    };
    this.currentField = 0;
    this.DateField = DateField;
  }
  created() {
    if (this.value) {
      this.formBuilderChange(this.value);
    }
  }
  handleInput(field, nextField, max) {
    if (this.canMoveNext(this.fullDate[field], max)) {
      this.currentField = nextField;
    }
  }
  handleDelete(event, currentField, previousField) {
    const field = this.fullDate[currentField];
    if (field === "" || field === null) {
      event.detail[0].preventDefault();
      this.currentField = previousField;
    }
  }
  get date() {
    const { $invalid: invalid } = this.$v.fullDate;
    if (!invalid) {
      const { day, month, year } = this.fullDate;
      return isoDate(day, month, year);
    }
    return null;
  }
  get hasValue() {
    return !!this.fullDate.day || !!this.fullDate.month || !!this.fullDate.year;
  }
  get infoDate() {
    if (this.date && this.date.length > 8 && this.amendDobHint) {
      const day = parseInt(this.fullDate.day, 10);
      const month = parseInt(this.fullDate.month, 10);
      const year = parseInt(this.fullDate.year, 10);
      const newDate = new Date(Date.UTC(year, month - 1, day));
      const locale = getLanguageTagBCP47(this.getLanguage());
      return `${day} ${newDate.toLocaleDateString(locale, {
        month: "long"
      })} ${year}`;
    }
    return this.info;
  }
  get hasAgeError() {
    if (!this.futureDateOnly) {
      return this.$v.fullDate.$error && (!this.$v.fullDate.maxAge || !this.$v.fullDate.minAge);
    }
  }
  onValueChange(value) {
    if (!value || value === this.date) {
      return;
    }
    this.fullDate = fromIsoDate(value);
  }
  onDateChange(date) {
    this.formBuilderChange(date);
    return date;
  }
  formBuilderChange(date) {
    const { $invalid: invalid } = this.$v.fullDate;
    return {
      isValid: !invalid,
      value: date
    };
  }
  get errorMessage() {
    if (this.hasError && this.message) {
      return this.message;
    }
    if (this.futureDateOnly && !this.$v.fullDate.allowedExpiryDate) {
      return this.$t("ui-date.date.error.expiry-date");
    }
    if (this.enableReasonableDob && !this.$v.fullDate.reasonableDateOfBirth) {
      return this.$t("ui-date.date.invalid");
    }
    if (this.minimumAge && !this.$v.fullDate.minAge) {
      return this.$t("ui-date.date.error.min-age", {
        minimumAge: this.minimumAge
      });
    }
    if (this.maximumAge && !this.$v.fullDate.maxAge) {
      return this.$t("ui-date.date.error.max-age", {
        maximumAge: this.maximumAge
      });
    }
    return this.$t("ui-date.date.invalid");
  }
  get hasDateError() {
    if (this.$v.fullDate.$error && (!this.isOptional || this.hasValue)) {
      return true;
    }
    return this.hasError;
  }
  canMoveNext(strValue, maximum) {
    const value = parseInt(strValue || "", 10);
    const isMaxLength = (strValue || "").length >= maximum.toString().length;
    if (value === null || Number.isNaN(value)) {
      return false;
    }
    const highestPossibleValid = value * 10 < maximum;
    return isMaxLength || value <= maximum && value > 0 && !highestPossibleValid;
  }
  getLanguage() {
    return this.magicConfig.language;
  }
};
__decorateClass([
  Prop(String)
], DateComponent.prototype, "value", 2);
__decorateClass([
  Prop(Number)
], DateComponent.prototype, "minimumAge", 2);
__decorateClass([
  Prop(Number)
], DateComponent.prototype, "maximumAge", 2);
__decorateClass([
  Prop(String)
], DateComponent.prototype, "info", 2);
__decorateClass([
  Prop(Boolean)
], DateComponent.prototype, "hasError", 2);
__decorateClass([
  Prop(String)
], DateComponent.prototype, "message", 2);
__decorateClass([
  Prop(Boolean)
], DateComponent.prototype, "enableReasonableDob", 2);
__decorateClass([
  Prop(Boolean)
], DateComponent.prototype, "futureDateOnly", 2);
__decorateClass([
  Prop(String)
], DateComponent.prototype, "futureDateStart", 2);
__decorateClass([
  Prop(Number)
], DateComponent.prototype, "futureYearLimit", 2);
__decorateClass([
  Prop(Boolean)
], DateComponent.prototype, "amendDobHint", 2);
__decorateClass([
  Prop(Boolean)
], DateComponent.prototype, "isOptional", 2);
__decorateClass([
  Watch("value", { immediate: true })
], DateComponent.prototype, "onValueChange", 1);
__decorateClass([
  Watch("date"),
  Emit("change")
], DateComponent.prototype, "onDateChange", 1);
__decorateClass([
  Emit("stand-alone-change")
], DateComponent.prototype, "formBuilderChange", 1);
DateComponent = __decorateClass([
  Component({
    name: "ui-date",
    validations() {
      const validations = {
        fullDate: {
          day: {
            required,
            validDay
          },
          month: {
            required,
            validMonth
          },
          year: {
            required,
            validYear
          }
        }
      };
      if (this.futureDateOnly) {
        validations.fullDate.allowedExpiryDate = (model) => acceptedExpiryDate({
          model,
          futureYearLimit: this.futureYearLimit,
          futureDateStart: this.futureDateStart ? new Date(this.futureDateStart) : void 0
        });
      }
      if (this.enableReasonableDob) {
        validations.fullDate.reasonableDateOfBirth = reasonableDateOfBirth;
      }
      if (this.minimumAge) {
        validations.fullDate.minAge = validAge(this.minimumAge);
      }
      if (this.maximumAge) {
        validations.fullDate.maxAge = maxValidAge(this.maximumAge);
      }
      if (this.isOptional && !this.hasValue) {
        for (const property in validations.fullDate) {
          validations.fullDate[property] = {};
        }
      }
      return validations;
    }
  })
], DateComponent);

export default DateComponent;
